import { render, staticRenderFns } from "./dangerRegularCheckTab.vue?vue&type=template&id=9924a4b6"
import script from "./dangerRegularCheckTab.vue?vue&type=script&lang=js"
export * from "./dangerRegularCheckTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9924a4b6')) {
      api.createRecord('9924a4b6', component.options)
    } else {
      api.reload('9924a4b6', component.options)
    }
    module.hot.accept("./dangerRegularCheckTab.vue?vue&type=template&id=9924a4b6", function () {
      api.rerender('9924a4b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/chm/danger/dangerRegularCheckTab.vue"
export default component.exports